import { Platform, StyleSheet } from 'react-native'
import { theme } from '../../../theme'

export const supportModalStyles = StyleSheet.create({
  modalOuter: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
  sheet: {
    width: '100%',
    maxWidth: 560,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: theme.gray[200],
    backgroundColor: theme.background.inset,
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 20,
    ...(Platform.OS === 'android' ? { elevation: 8 } : {}),
  },
  title: {
    color: theme.white,
    fontSize: 20,
    fontWeight: '800',
    marginBottom: 4,
  },
  subtitle: {
    color: theme.gray[500],
    fontSize: 13,
    lineHeight: 19,
    marginBottom: 18,
  },
  label: {
    color: theme.gray[700],
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    marginBottom: 8,
  },
  inputGroup: {
    marginBottom: 14,
  },
  categoryRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 16,
  },
  categoryChip: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: theme.gray[200],
    backgroundColor: theme.background.card,
  },
  categoryChipActive: {
    borderColor: theme.primary,
    backgroundColor: 'rgba(167, 139, 250, 0.15)',
  },
  categoryChipPressed: {
    opacity: 0.75,
  },
  categoryChipText: {
    color: theme.gray[600],
    fontSize: 13,
    fontWeight: '500',
  },
  categoryChipTextActive: {
    color: theme.primaryLight,
    fontWeight: '700',
  },
  textInput: {
    backgroundColor: theme.background.card,
    borderWidth: 1,
    borderColor: theme.gray[200],
    borderRadius: 10,
    color: theme.white,
    fontSize: 14,
    paddingHorizontal: 13,
    paddingVertical: 11,
  },
  textInputFocused: {
    borderColor: theme.primary,
  },
  messageInput: {
    minHeight: 100,
    textAlignVertical: 'top',
  },
  charCount: {
    color: theme.gray[400],
    fontSize: 11,
    textAlign: 'right',
    marginTop: 4,
  },
  errorText: {
    color: theme.error,
    fontSize: 12,
    marginTop: 4,
  },
  submitButton: {
    marginTop: 8,
    minHeight: 46,
    borderRadius: 10,
    backgroundColor: theme.primaryDark,
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitButtonDisabled: {
    opacity: 0.5,
  },
  submitButtonPressed: {
    opacity: 0.85,
  },
  submitButtonText: {
    color: theme.white,
    fontSize: 15,
    fontWeight: '700',
  },
  closeButton: {
    marginTop: 8,
    minHeight: 42,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: theme.gray[200],
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  closeButtonPressed: {
    opacity: 0.75,
  },
  closeButtonText: {
    color: theme.gray[600],
    fontSize: 14,
    fontWeight: '600',
  },
  successContainer: {
    alignItems: 'center',
    paddingVertical: 28,
  },
  successTitle: {
    color: theme.white,
    fontSize: 18,
    fontWeight: '800',
    marginTop: 14,
    marginBottom: 8,
  },
  successMessage: {
    color: theme.gray[500],
    fontSize: 13,
    lineHeight: 19,
    textAlign: 'center',
    marginBottom: 24,
  },
})
